import { OnInit, Output, Input, Component, EventEmitter, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TypeaheadMatch } from 'ngx-bootstrap';import { ProgramService } from '../../../client-core/services/program.service';
import { TypeaheadConfig } from '../typeahead-config.model';
import { AppDatatableConfigOptions } from '../../datatable/models/config-options.model';
import { PaginationInfo } from '../../../client-core/api-response-models/pagination-info.model';
import { TypeaheadLookupComponent } from '../typeahead-lookup-component';

@Component({
    selector: 'countries-typeahead',
    templateUrl: 'countries-typeahead.component.html'
})
export class CountriesTypeaheadComponent implements OnInit {

    @Input()
    config: TypeaheadConfig;

    @Input()
    placeholder?: string;

    @Output()
    onClicked = new EventEmitter<TypeaheadMatch>();

    @Output()
    onSelected = new EventEmitter<TypeaheadMatch>();

    @Input() disabled: boolean;

    @ViewChild('typeahead') typeahead: TypeaheadLookupComponent

    public list: Observable<any>;
    public listSearchTerm?: string;
    public listColumns: Observable<Array<any>>;
    public listConfig: Observable<AppDatatableConfigOptions>;
    public paginationInfo: Observable<PaginationInfo>;
    public paginationParams: any = {};

    public listSelected: TypeaheadMatch;
    public fetchObservable: number = 0;

    constructor(private service: ProgramService) {
        this.config = TypeaheadConfig.CreateDefaultCountriesLookupTypeaheadConfig();
    }

    ngOnInit() {
        //configure columns
        let listColumns = [
            { prop: "item.countryCode", name: "Code", minWidth: 150 },
            { prop: "item.name", name: "Name", minWidth: 250 }
        ];

        this.listColumns = Observable.of(listColumns);

        let listConfig = new AppDatatableConfigOptions();
        let rowGrouperLabelGetter = function (row: any) {
            return row.item.categoryId;
        };
        //configure table with row grouper
        listConfig.compact = true;
        listConfig.headerHeight = 30;
        listConfig.footerHeight = 30;
        listConfig.loadingIndicator = false;
        listConfig.rowGrouperHeight = 30;
        listConfig.rowGrouperAllowToggle = false;
        listConfig.rowGrouperLabelGetter = rowGrouperLabelGetter;
        //listConfig.groupRowsBy = "item.categoryId";
        listConfig.scrollbarHorizontal = false;
        listConfig.scrollbarVertical = false;
        this.listConfig = Observable.of(listConfig);
        //initialze data
        this._refreshList();
    }

    cleartext() {
        this.typeahead.clearText();
    }

    private _refreshList(): void {

        this.list = Observable.create((observer: any) => {
            let queryParams = { };
            if (this.listSearchTerm) {
                queryParams["searchTerm"] = this.listSearchTerm;
            }

            queryParams = Object.assign({}, queryParams, this.paginationParams);

            console.log(">>> observer", queryParams);
            this.service.getCountriesLookup(queryParams)
                .subscribe(res => {
                    if (!res.hasError) {
                        if (res.data) {
                            let data = res.data;
                            let paginationInfo = PaginationInfo.createForApiPagedResponse(res.data);
                            this.paginationInfo = Observable.of(paginationInfo);
                            observer.next(res.data.items);
                        }
                        else {
                            //this.validationMessages = new ValidationMessage(null, true, "Account lookup could not be loaded");
                        }
                    } else {
                        //this.validationMessages = new ValidationMessage(res._error, true, "Account lookup could not be loaded");
                    }
                },
                (err: any) => {
                    //this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured when loading Account lookup");
                });
        });
    }

    toObservable(matches: Array<any>): Observable<any> {
        if (matches) {
            return Observable.of(matches);
        } else {
            return Observable.of([]);
        }
    }

    onTableAction(event: any = {}): void {
        if (event.pageIndex || event.pageIndex === 0) {
            this.paginationParams = event;
            if (event.sortBy) {
                this.paginationParams.sortBy = event.sortBy.replace(/item\./, "");
            }
            this.fetchObservable++;
        }
        console.log(">>> onTableAction", this.paginationParams);
    }

    onTableActionDone(event: any): void {
    }

    onRowActivate(event: any): void {
    }

    onRowSelect(event: any): void {
        if (event.selected && event.selected.length > 0) {
            let item = event.selected[0];
            this.listSelected = item;
        }
    }

    onSelectedCallback(event: any): void {
        //console.log(">> onSelectedCallback", event);
        this.onSelected.emit(event);
    }

    onSearchTermChanged(term): void {
        //console.log('>>onSearchTermChanged', term);
        this.listSearchTerm = term;
        this.paginationParams.pageIndex = 0;
    }

    onButtonClicked(event: any): void {
        this.onClicked.emit(event);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/typeahead/typeaheads/countries-typeahead.component.ts